import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import CalendarPanel from './components/CalendarPanel';
import UserAnalyticsPanel from './components/UserAnalyticsPanel';
import BannedUsersPanel from './components/BannedUsersPanel';
const AppRouter = () => {
    // Get room configuration from server (same as index.tsx)
    const config = window.gridchatConfig || {
        roomId: 'default',
        roomName: 'GridChat',
        isDefaultRoom: true
    };
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(App, { config: config }) }), _jsx(Route, { path: "/calendar", element: _jsx(CalendarPanel, {}) }), _jsx(Route, { path: "/analytics", element: _jsx(UserAnalyticsPanel, {}) }), _jsx(Route, { path: "/banned-users", element: _jsx(BannedUsersPanel, {}) })] }) }));
};
export default AppRouter;
